const LauncherIcons = {
  "wheel_icon": "https://influencex-profile-pictures.nyc3.cdn.digitaloceanspaces.com/wheelIcon.webp",
  "gift_animation": "https://influencex-profile-pictures.nyc3.cdn.digitaloceanspaces.com/gift-anime.gif",
  "percent_icon": "https://influencex-profile-pictures.nyc3.cdn.digitaloceanspaces.com/perc.png",
  "percent_icon_dark": "https://influencex-profile-pictures.nyc3.cdn.digitaloceanspaces.com/perc_black.png",
  "gift": "https://influencex-profile-pictures.nyc3.cdn.digitaloceanspaces.com/gift-anime.gif"
}

export default LauncherIcons